const dev = {
    environment: "dev",
};

const prod = {
    environment: "prod",
};



export const config = process.env.REACT_APP_STAGE === 'production'
    ? prod
    : dev;


// WEBPACK FOOTER //
// ./src/config.js